import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

export const useIsEditCartEnabled = ({ isOffer }: { isOffer?: boolean } = {}) => {
  const enableEditCart = useFlag(LaunchDarklyFlag.ENABLE_EDIT_CART);
  const enableOffersEditCart = useFlag(LaunchDarklyFlag.ENABLE_OFFERS_EDIT_CART);
  return isOffer ? enableEditCart && enableOffersEditCart : enableEditCart;
};
